import { useAuth } from "./AuthContext";
import { LOGO_URL } from "../assets/images";
import { ShieldCheck, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();

  // If already authenticated, go straight to admin
  if (user) {
    window.location.replace("/admin");
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--secondary))] p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-[hsl(var(--border))] p-10 sm:p-12 shadow-sm">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="CIEES" className="h-14 w-14" />
          <div>
            <div className="display-heading text-xl text-[hsl(var(--primary))]">CIEES Portugal</div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-[hsl(var(--muted-foreground))]">
              Painel de Administração
            </div>
          </div>
        </div>

        <h1 className="display-heading text-3xl sm:text-4xl mt-10 leading-[1.1]">
          Entrar no painel.
        </h1>
        <span className="accent-rule mt-6 block" />

        <p className="mt-6 text-[hsl(var(--muted-foreground))] leading-relaxed text-[15px]">
          O painel de administração é exclusivo dos membros da Direção do CIEES Portugal. O acesso é feito com a sua conta Google institucional.
        </p>

        <button
          type="button"
          onClick={login}
          className="mt-10 w-full inline-flex items-center justify-center gap-3 px-6 py-4 bg-[hsl(var(--primary))] text-white text-sm uppercase tracking-[0.18em] font-medium hover:bg-[#093630] transition-all"
          data-testid="admin-login-google-button"
        >
          <ShieldCheck className="h-4 w-4" />
          Entrar com Google
          <ArrowRight className="h-4 w-4" />
        </button>

        <p className="mt-8 text-xs text-[hsl(var(--muted-foreground))] leading-relaxed">
          Se o seu email não estiver na lista de administradores, o acesso será negado. Contacte a direção para ser adicionado.
        </p>

        <a
          href="/"
          className="mt-10 block text-xs uppercase tracking-[0.22em] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))] transition-colors"
          data-testid="admin-login-back-home"
        >
          ← Voltar ao site
        </a>
      </div>
    </div>
  );
}
